module.exports = __webpack_public_path__ + "img/history_timeline_9.5ca1a113.png";